import React from 'react';

function PeopleDetection() {
  return (
    <div className="container-fluid mt-4">
      <div className="text-center mb-4">
        <img
          src="/assets/images/projects/people_detection/image1_700x300.svg"
          alt="People Detection Banner"
          className="img-fluid rounded shadow"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
      <h2 className="mb-4">
        <i className="fas fa-eye text-success"></i> People Detection (YOLOv12n)
      </h2>
      <div className="alert alert-info">
        <i className="fas fa-info-circle"></i> Detección de personas y objetos en tiempo real usando <strong>YOLOv12n</strong> convertido a TFLite.
        24 clases detectables con inferencia de ~1.9ms por imagen.
      </div>
      <div className="embed-responsive" style={{ height: '80vh' }}>
        <iframe
          src="http://www.cloudsapps.net:8503/"
          title="People Detection"
          className="embed-responsive-item w-100 h-100"
          style={{ border: '1px solid #ddd', borderRadius: '8px' }}
          allow="accelerometer; camera; microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        />
      </div>
    </div>
  );
}

export default PeopleDetection;
